/* global axios */

import ApiClient from '../ApiClient';

class JiraAPI extends ApiClient {
  constructor() {
    super('integrations/jira', { accountScoped: true });
  }

  createIssue(conversationId) {
    return axios.post(`${this.url}/create_issue`, {
      conversation_id: conversationId,
    });
  }
}

export default new JiraAPI();
